import { render, staticRenderFns } from "./ShowVideoUrl.vue?vue&type=template&id=55a10be8&scoped=true&"
import script from "./ShowVideoUrl.vue?vue&type=script&lang=js&"
export * from "./ShowVideoUrl.vue?vue&type=script&lang=js&"
import style0 from "./ShowVideoUrl.vue?vue&type=style&index=0&id=55a10be8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a10be8",
  null
  
)

export default component.exports